export default function getFormatedDate(date) {
  const dateTimeStamp = new Date(date);
  const weekday = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ][dateTimeStamp.getDay()];

  const addZeroToMinutes = (timeStamp) => {
    return (timeStamp.getMinutes() < 10 ? "0" : "") + timeStamp.getMinutes();
  };

  const hour = dateTimeStamp.getHours();
  let minutes = dateTimeStamp.getMinutes();
  minutes = addZeroToMinutes(dateTimeStamp);
  const day = dateTimeStamp.getDate();
  const month = dateTimeStamp.getMonth() + 1;
  const year = dateTimeStamp.getFullYear();

  return {
    hour,
    minutes,
    day,
    weekday,
    month,
    year,
  };
}
